export const createLink = (url, text) => {
    return (
        <a href={url} target="_blank" rel="noreferrer">
            {text}
        </a>
    );
};

export const convertsSecondsToTime = (seconds) => {
    const sec = Number(seconds);

    if (isNaN(sec) || sec < 0) {
        return "00:00:00";
    }

    const date = new Date(0);
    date.setSeconds(sec);

    return date.toISOString().substr(11, 8);
};

export const convertBytesToReadable = (bytes) => {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
};

export const convertDateToReadable = (date) => {
    const parsedDate = new Date(date);

    if (isNaN(parsedDate)) {
        return "Invalid date";
    }

    const options = { year: "numeric", month: "long", day: "numeric" };
    return parsedDate.toLocaleDateString(undefined, options);
};

export const convertBooleanString = (booleanString) => {
    if (
        booleanString === "true" ||
        booleanString === "1" ||
        booleanString === true
    ) {
        return "Yes";
    } else if (
        booleanString === "false" ||
        booleanString === "0" ||
        booleanString === false
    ) {
        return "No";
    } else {
        return booleanString;
    }
};

export     const buildFeaturedImageUrl = (slug, featuredImageUrl) => {
        const baseUrl = "https://churchcamlive.ie";
        const sizeString = "768x432";
        const imageUrl = `/assets/images/background-images/${slug}`;
        const lastDotIndex = featuredImageUrl.lastIndexOf(".");
        const extension = featuredImageUrl.substring(lastDotIndex);

        return `${baseUrl}${imageUrl}-${sizeString}${extension}`;
    }